import { Component } from '@angular/core';
import { SendPaymentInstructionModelService } from '@pg-app/client/send-payment-instruction/services/send-payment-instruction.model.service';

@Component({
  selector: 'np-send-payment-modal',
  templateUrl: './send-payment-modal.component.html',
  styleUrls: ['./send-payment-modal.component.scss']
})
export class SendPaymentModalComponent {

  constructor(
    public sendPaymentModel: SendPaymentInstructionModelService
  ) {
  }
}





